import { useTranslation } from "react-i18next";
import { useCallback } from "react";

import { showInformationAlert } from "@components/molecules/alert";
import { InviteGuest } from "@components/organisms/videoVisit/components/inviteGuest/inviteGuest";
import type { ID } from "@constants";

export const useInviteGuest = () => {
  const { t } = useTranslation("form");

  const inviteGuest = useCallback(
    (id?: ID) => {
      showInformationAlert({
        title: t("invite_guest_title"),
        content: t("invite_guest_text"),
        noButtons: true,
        children: <InviteGuest id={id} />,
      });
    },
    [t],
  );

  return { inviteGuest };
};
